// CronometroContext.js
import React, { createContext, useState } from 'react';

export const CronometroContext = createContext();

export const CronometroProvider = ({ children }) => {
  const [configurations, setConfigurations] = useState({
    fontSize: 'clamp(2rem, 5vw, 4rem)', // Valor predeterminado responsivo
    fontColor: '#00ff00',
    backgroundColor: '#000000',
    // ... otras configuraciones
  });

  return (
    <CronometroContext.Provider value={{ configurations, setConfigurations }}>
      {children}
    </CronometroContext.Provider>
  );
};
